import { Security } from '../models';

export function mapToSecurity(securityIds: number[]): Security[] {
  return securityIds.map(id => <Security>{ id });
}
